import React, { Component } from 'react';
import Shimmer from 'sushiweb/Shimmer';
import './Merchant.scss';
import { Plus, InfoLine, ChevronUp, ChevronDown } from 'sushiweb/Icons';
import { grey, green } from 'sushiweb/tokens/color';
import { Modal, Tooltip, CopyText, Label } from '../../../UiKit';
import { WFHCall } from '../../../components/commons';
import { MerchantNumber } from './MerchantNumber';
import { AlternativeNumbers, MerchantHistory } from '../../popups';
import { merchantModel } from '../../../api';
import { headPhone, grocery } from '../../../images/images';
import {
  MERCHANT_EVENTS,
  sendMerchantApiEvents,
  sendMerchantModalEvents,
} from '../../../helpers/analytics/merchant.analytics';
import { OrdersInSameCart } from '../Order/OrderBasicInfo/OrdersInCartModal';
import { OrderIssuesImages } from '../Order/OrderIssuesImages/OrderIssuesImages';
import { InstallationDetails } from '../InstallationDetails/InstallationDetails';
import { OrderKycStatus } from '../Order/OrderBasicInfo/OrderKycStatus';
import { RiderComplaintImages } from '../Valet/RiderComplaintImages/RiderComplaintImages';
import { MerchantCallClickEvent } from '../../../analytics/call-logging/events';

export default class Merchant extends Component {
  constructor(props) {
    super(props);
    this.state = {
      merchant: null,
      selectedMerchantTag: {},
    };
  }

  componentDidMount() {
    this.getMerchantInfo();
  }

  getMerchantInfo = () => {
    const { orderId, userId } = this.props;
    let queryStrings = {};
    queryStrings['order_id'] = orderId;
    merchantModel
      .getMerchantData(queryStrings)
      .then((response) => {
        if (!response || response?.isError === true) return null;
        sendMerchantApiEvents(
          MERCHANT_EVENTS.GET_MERCHANT_DETAILS_SUCCESS,
          orderId,
          userId,
        );
        this.setState({
          merchant: { ...response },
        });
      })
      .catch(() => {
        sendMerchantApiEvents(
          MERCHANT_EVENTS.GET_MERCHANT_DETAILS_FAILURE,
          orderId,
          userId,
        );
      });
  };

  render() {
    const { merchant } = this.state;
    return (
      <div className='merchantContainer col'>
        {!merchant ? (
          <Shimmer height='150px' width='100%' />
        ) : (
          <MerchantComp {...this.props} merchant={merchant} />
        )}
      </div>
    );
  }
}
class MerchantComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showAlternativeNumbersPopup: false,
      showMerchantHistoryPopup: false,
      merchantHistory: null,
      showTagDescription: false,
      showAllMerchantinfo: false,
    };
  }

  closeAlternativeNumbersPopup = () => {
    const { orderId, userId } = this.props;
    sendMerchantModalEvents(
      MERCHANT_EVENTS.MERCHANT_ALTERNATE_NUMBER_MODAL_CLOSE,
      orderId,
      userId,
    );
    this.setState({
      showAlternativeNumbersPopup: false,
    });
  };

  showAlternativeNumbersPopup = (alternateNumbers) => {
    const { orderId, userId } = this.props;
    sendMerchantModalEvents(
      MERCHANT_EVENTS.MERCHANT_ALTERNATE_NUMBER_MODAL_OPEN,
      orderId,
      userId,
    );
    this.setState({
      showAlternativeNumbersPopup: true,
      alternativeNumbers: alternateNumbers,
    });
  };

  getPhoneNumbers = (details) => {
    const { orderId, userId, isWFH, cartId } = this.props;
    let calledTo = 'Merchant';
    if (details?.role === 'Depot Manager') {
      calledTo = details?.role;
    }

    if (!details?.phone) return null;
    return (
      <div className='wrap'>
        <div style={{ width: '100%' }}>
          <Tooltip
            position='bottom'
            border={false}
            title={
              <div className='pointer lighter'>
                {details.name.length > 12
                  ? details.name.substring(0, 12) + '...'
                  : details.name}
                <div className='tw-ml-1'>
                  {window.dashboard.mode === 'lifelineZ'
                    ? details.role.length > 13
                      ? details.role.substring(0, 13) + '...'
                      : details.role
                    : details.role}
                </div>
              </div>
            }
            label={
              details.name +
              (details.email && details.email != 'None'
                ? ' - ' + details.email
                : '')
            }
            maskData={true}
          />
        </div>
        <div style={{ width: '100%' }}>
          <span className='icon iconMarginR'>
            <img src={headPhone} alt='' />
          </span>
          <MerchantNumber
            phone={details?.phone}
            designation={details?.role}
            calledTo={calledTo}
            orderId={orderId}
            userId={userId}
          />
          {isWFH ? (
            <WFHCall
              orderId={orderId}
              userId={userId}
              title={details.phone}
              calledTo={calledTo}
              calledToType={details.role}
              sendJumboEvent={true}
              jumboEventFunc={MerchantCallClickEvent}
              JumboEventProperties={{
                merchant_name: details?.name,
                is_new_ui: false,
                called_to: calledTo,
                role: details?.role,
                phone: details?.phone,
              }}
              cartId={cartId}
            />
          ) : null}
        </div>
      </div>
    );
  };

  handleMerchantDetails = () => {
    const showDetails = this.state.showAllMerchantinfo;
    this.setState({
      showAllMerchantinfo: !showDetails,
    });
  };

  getAllPhoneNumbers = (
    smDetails,
    tlDetails,
    asmDetails,
    depoDetails,
    alternateNumbers,
  ) => {
    const { showAllMerchantinfo } = this.state;
    const allDetails = [];
    if (depoDetails?.phone) allDetails.push(depoDetails);
    if (smDetails?.phone) allDetails.push(smDetails);
    if (tlDetails?.phone) allDetails.push(tlDetails);
    if (asmDetails?.phone) allDetails.push(asmDetails);
    return (
      <div className='wrap tw-w-full'>
        {allDetails?.length > 1 ? (
          showAllMerchantinfo ? (
            <div className='tw-flex-col'>
              {allDetails.map((details) => {
                return <div>{this.getPhoneNumbers(details)}</div>;
              })}
              <div
                className='colorGreen tw-text-300 tw-font-regular'
                onClick={this.handleMerchantDetails}
              >
                View Less <ChevronUp color={'#50b547'} />
              </div>
            </div>
          ) : (
            <div className='tw-flex-col'>
              {this.getPhoneNumbers(allDetails[0])}
              <div
                className='colorGreen tw-text-300 tw-font-regular'
                onClick={this.handleMerchantDetails}
              >
                View More <ChevronDown color={'#50b547'} />
              </div>
            </div>
          )
        ) : allDetails?.length === 0 ? null : (
          allDetails.map((details) => {
            return <>{this.getPhoneNumbers(details)}</>;
          })
        )}

        <div>
          {alternateNumbers?.length ? (
            <Tooltip
              position='bottom'
              border={false}
              title={
                <span
                  className='pointer'
                  onClick={this.showAlternativeNumbersPopup.bind(
                    this,
                    alternateNumbers,
                  )}
                >
                  <Plus size={20} color={green.z500} />
                </span>
              }
              label='Other Contact Numbers'
            />
          ) : null}
        </div>
      </div>
    );
  };

  getMerchantHistory = () => {
    const { orderId, userId } = this.props;
    const querryParams = {};
    querryParams['order_id'] = orderId;
    merchantModel
      .getMerchantHistory(querryParams)
      .then((response) => {
        if (!response || response?.isError === true) return null;
        sendMerchantApiEvents(
          MERCHANT_EVENTS.GET_MERCHANT_HISTORY_SUCCESS,
          orderId,
          userId,
        );
        sendMerchantModalEvents(
          MERCHANT_EVENTS.MERCHANT_HISTORY_MODAL_OPEN,
          orderId,
          userId,
        );
        this.setState({
          merchantHistory: { ...response },
          showMerchantHistoryPopup: true,
        });
      })
      .catch(() =>
        sendMerchantApiEvents(
          MERCHANT_EVENTS.GET_MERCHANT_HISTORY_FAILURE,
          orderId,
          userId,
        ),
      );
  };

  closeMerchantHistoryPopup = () => {
    const { orderId, userId } = this.props;
    sendMerchantModalEvents(
      MERCHANT_EVENTS.MERCHANT_HISTORY_MODAL_CLOSE,
      orderId,
      userId,
    );
    this.setState({
      showMerchantHistoryPopup: false,
    });
  };

  render() {
    const { order, merchant, orderId, userId, isWFH } = this.props;

    const {
      showAlternativeNumbersPopup,
      alternativeNumbers,
      showMerchantHistoryPopup,
      merchantHistory,
    } = this.state;

    const label = merchant?.label;
    const smDetails = merchant?.sm_details;
    const tlDetails = merchant?.tl_details;
    const asmDetails = merchant?.asm_details;
    const depoDetails = merchant?.depo_details;

    const alternateNumbers =
      merchant?.alternate_numbers && merchant?.alternate_numbers?.split(',');

    const display_text = merchant?.disruption;

    return (
      <React.Fragment>
        <div className='merchantInfo tw-flex-col tw-justify-between tw-h-full' data-dd-privacy='mask'>
          <div className='tw-flex-col tw-w-full'>
            <div className='lighter wrap'>
              <span
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <img src={grocery} className='tw-size-10' alt='grocery' />
              </span>
              <span>{label}&nbsp;#</span>
              <CopyText title={merchant.id} />
            </div>
            <h3 className='merchantName dark'>
              <p className='nameStr dark large'>{merchant.name}</p>
            </h3>
            <div className='tags'>
              {merchant.tags?.map((item, index) => {
                if (!item) return null;
                return (
                  <div key={index}>
                    <Tooltip
                      position='top'
                      title={
                        <Label
                          title={item.text}
                          bgColor={item.bg_color}
                          textColor={item.color}
                        />
                      }
                      border={false}
                      titleColor={item.color}
                      fontWeight={300}
                      fontSize={14}
                      label={item?.tool_tip}
                    />
                  </div>
                );
              })}
            </div>
            {this.getAllPhoneNumbers(
              smDetails,
              tlDetails,
              asmDetails,
              depoDetails,
              alternateNumbers,
            )}
          </div>

          <div className='tw-flex-col'>
            <OrdersInSameCart cartId={this.props.cartId} />

            {/* Overall complaint images */}
            <OrderIssuesImages orderId={orderId} userId={userId} />

            {/* Rider Uploaded images */}
            {order?.should_show_rider_image ? (
              <RiderComplaintImages orderId={orderId} userId={userId} />
            ) : null}

            {order?.show_activation_details ? (
              <OrderKycStatus orderId={orderId} userId={userId} />
            ) : null}

            {order?.is_installation_opted ? (
              <InstallationDetails orderId={orderId} />
            ) : null}
          </div>
        </div>

        {display_text?.title && (
          <div className='closingTime '>
            <span className='icon iconMarginR infoIcon'>
              <InfoLine size={14} color={grey.z500} />
            </span>
            <Tooltip
              position='bottom'
              title={
                <p style={{ color: display_text.color }}>
                  {display_text.title}
                </p>
              }
              titleColor={display_text.color}
              fontWeight={300}
              fontSize={14}
              label={display_text.subtitle}
            />
          </div>
        )}

        <Modal
          isVisible={showAlternativeNumbersPopup}
          title='Other Merchant Contact Numbers'
          type='medium'
          handleClose={this.closeAlternativeNumbersPopup.bind(this)}
          component={
            <AlternativeNumbers
              alternativeNumbers={alternativeNumbers}
              orderId={orderId}
              userId={userId}
              isWFH={isWFH}
              calledTo='Merchant'
            />
          }
        />
        <Modal
          isVisible={showMerchantHistoryPopup}
          type='large'
          title={`${merchantHistory?.header_text || 'Restaurant details'}`}
          handleClose={this.closeMerchantHistoryPopup.bind(this)}
          component={<MerchantHistory merchantHistory={merchantHistory} />}
        />
      </React.Fragment>
    );
  }
}
